module.exports = __webpack_public_path__ + "media/images/heroSlider-f180e9e9238e37844ffe2ada49e37cf3.jpg";